import { all } from 'redux-saga/effects';
import envInfoSaga from './envInfoSaga';

export default function* rootSaga() {
  yield all([
    envInfoSaga(),
  ]);
}
